import DeleteIcon from '@mui/icons-material/Delete';
import { useCallback, useEffect, useState } from 'react';
import editButton from '../../assets/images/editButton.png';
import axios from '../../functions/axios';
import { parseDate } from '../../functions/functions';
import { useAuthContext } from '../../hooks/useAuthContext';
import { DateSelector } from './DateSelector';
import { useNavigate, useLocation } from 'react-router-dom';
import { Autocomplete, Box, Button, CircularProgress, Grid, Paper, TextField } from '@mui/material';
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const DataLoading = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <CircularProgress />
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Pobieranie danych</Box>
    </Box>
  );
};

function CarriageNotes(props) {
  const location = useLocation();
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(false);
  const initDate = parseDate(Date.parse(location.state?.date || new Date()));
  const [dayStart, setDayStart] = useState(initDate.monday);
  const [dayEnd, setDayEnd] = useState(initDate.sunday);
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    try {
      const params = {
        startDate: parseDate(dayStart).day,
        endDate: parseDate(dayEnd).day,
        context: 'carriageNotes',
      };
      const response = await axios.get('/notes', { params, context: 'carriageNotes' });

      setApiData(response.data);
    } catch (err) {
      console.log(err);
    }
  }, [dayEnd, dayStart]);

  useEffect(() => {
    if (!user) return;
    getData();

    const intervalId = setInterval(() => {
      getData();
    }, 30_000);

    return () => {
      clearInterval(intervalId);
    };
  }, [getData, user]);

  if (!user) {
    return null;
  }

  if (loading) {
    return <DataLoading />;
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Paper sx={{ height: 'calc(100vh - 80px)', overflow: 'auto' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              margin: '0 5px 15px 0',
              padding: '10px',
            }}
          >
            <DateSelector
              dayStart={dayStart}
              dayEnd={dayEnd}
              setDayStart={setDayStart}
              setDayEnd={setDayEnd}
              searchButtonClick={getData}
              setLoading={setLoading}
            />
            <Button variant='contained' color='primary' onClick={navigate.bind(null, '/carriageNotes/create', { state: { date: initDate.monday } })}>
              Nowy ładunek
            </Button>
          </Box>
          {apiData && apiData.length === 0 && (
            <Box
              style={{
                margin: '30px',
              }}
            >
              Brak danych do wyświetlenia...
            </Box>
          )}
          {(apiData ?? []).map((record) => {
            if (!record) return null;
            return (
              <Paper
                onClick={navigate.bind(null, `/carriageNotes/${record._id}`)}
                key={record._id}
                elevation={6}
                sx={{
                  margin: '18px 20px',
                  padding: '18px 22px',
                  border: '1.5px solid #333',
                  borderRadius: '14px',
                  background: 'linear-gradient(135deg, #232526 0%, #1a1a1a 100%)',
                  boxShadow: '0 4px 24px 0 rgba(0,0,0,0.25)',
                  cursor: 'pointer',
                  transition: 'transform 0.12s, box-shadow 0.12s',
                  '&:hover': {
                    boxShadow: '0 6px 32px 0 rgba(0,0,0,0.35)',
                    borderColor: '#1976d2',
                  },
                }}
              >
                <Grid container alignItems='center' spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sx={{ color: '#e0e0e0', fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}
                  >
                    {record.value}
                  </Grid>
                </Grid>
              </Paper>
            );
          })}
        </Paper>
      </Grid>
    </Grid>
  );
}

export default CarriageNotes;
